import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar.js";
import { Grid } from "../core/components/grid.js";
import { General } from "../../siteManagement/general.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { Helper } from "../core/util/helper.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import React from "react";
export default class AddressContacts extends React.Component<any, any>{
    private _gridData = [];
    private _gridOptions = {};
    private _translations = {};
    private _dataUrl: string;
    private _singleItem = false;
    private _enabled: boolean;

    constructor(props) {
        super(props);
        this._enabled = true;
        this._dataUrl = "ProjectContactPersons/GetAddressGridData?id=" + props.entity.Projnr;
        this._gridOptions = props.context.addressContactsGrid;
        this._translations = props.translations;
    }

    private _getGridData() {
        HTTPService.get(this._dataUrl)
            .then(result => {
                this._gridData = result.Data.GridData;
                this.setState({});
            });
    }

    private _add = () => {
        const url = "Contact/New?isWindow=true&adrNr=" + this.props.entity.Adrnr;
        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true, preventUrlChangeOnNew: true });
        sheet.setTitle(this._translations["Ansprechpartner.Ansprechpartner"]);
        sheet.bind(SheetEventType.SavedSuccessfully, () => {
            this._getGridData();
        });
    }

    private _edit = (dataItem: any) => {
        const url = 'Contact/Edit?isWindow=true&id=' + encodeURIComponent(dataItem.Pos);
        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true });
        sheet.setTitle(this._translations["WebSMS.Title.ContactEditing"]);
        sheet.bind(SheetEventType.SavedSuccessfully, () => {
            this._getGridData();
        });
    }

    private _onSelected = (items: {} | Array<{}>) => {
        const prev = this._singleItem;
        this._singleItem = Helper.hasValue(items) && !Array.isArray(items);
        if (prev !== this._singleItem) {
            this.setState({});
        }
    }


    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.NEW) {
            this._add();
        } else if (type === ToolBarStandardButtonType.EDIT) {
            this._edit(dataItem);
        }
    }

    handleClickCustomButton = (id: string, dataItem: any, dataItems: Array<any>) => {
        if (id === "addToProject") {
            if (Helper.hasValue(dataItems) && dataItems.length > 0) {
                HTTPService.post<JsonResultClass>(
                    'ProjectContactPersons/AddToProject',
                    {
                        GridData: dataItems,
                        Project: this.props.entity
                    }
                )
                    .then(result => {
                        if (result.Code === 0) {
                            $(window).trigger("contactPersonAdded");
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        }
    }

    private _setEvents = () => {
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.Custom, (cus) => {
            if (cus.command === "projectStatusChanged") {
                this._enabled = cus.value;
                this.setState({});
            }
        });
    }

    private _checkEditability = () => {
        if (this.props.context.contextType === "project") {
            this._enabled = this.props.entity.ProjectStatus.Editing;
            this.setState({});
        }
    }

    componentDidMount() {
        this._setEvents();
        this._checkEditability();
        this._getGridData();
    }

    render() {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: this._translations["Standard.Neu"], enabled: this.props.entity.RecordRight.CanWrite && this._enabled });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: this._translations["Standard.Editieren"], enabled: this.props.entity.RecordRight.CanWrite && this._singleItem && this._enabled });

        const customButtons: Array<GridCustomToolBarButton> = [];
        customButtons.push({
            id: "addToProject", enabled: this.props.entity.RecordRight.CanWrite && this._enabled, caption: this._translations["Standard.Add"], iconClass: "k-i-plus", autoEnabledOnRecordSelected: true
        });

        const content = <Grid data={this._gridData} options={this._gridOptions} id="projectAddressContacts"
            standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton}
            customButtons={customButtons} onClickCustomButton={this.handleClickCustomButton} onSelectionChanged={this._onSelected} copyCellValue={true} />

        return (content);
    }
}